import { Link } from "react-router-dom";
import { ArrowRight, FolderKanban } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { usePublishedProjects, ProjectCard } from "@/components/ProjectsGallery";

const References = () => {
  useSEO({
    title: "Referencer | Udvalgte projekter – AA+PLUS MILJØSANERING",
    description: "Se udvalgte bygge-, renoverings- og nedrivningsprojekter udført af AA+PLUS MILJØSANERING for danske erhvervskunder.",
  });
  const projects = usePublishedProjects();

  return (
    <div data-testid="references-page">
      <section className="bg-[#1F2937] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">Referencer</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl">Udvalgte projekter</h1>
          <p className="mt-5 text-lg text-gray-300 max-w-2xl leading-relaxed">
            Et udvalg af de opgaver, vi har udført for danske erhvervskunder.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {projects === null ? (
            <p className="text-gray-500">Indlæser referencer...</p>
          ) : projects.length === 0 ? (
            <div className="bg-gray-50 border border-gray-200 rounded-sm p-12 lg:p-16 text-center" data-testid="references-empty">
              <FolderKanban className="text-[#FF5A00] mx-auto mb-5" size={44} />
              <h2 className="text-2xl font-bold text-gray-900">Referencer på vej</h2>
              <p className="mt-3 text-gray-600 max-w-xl mx-auto">
                Vi offentliggør udvalgte projekter her, efterhånden som de er afsluttet og dokumenteret. Kontakt os gerne for at høre nærmere om vores erfaring og igangværende opgaver.
              </p>
              <Link to="/kontakt" data-testid="references-cta-btn" className="mt-8 inline-flex items-center gap-2 bg-[#FF5A00] text-white font-semibold px-7 py-3.5 rounded-sm hover:bg-[#E04F00] transition-colors">
                Kontakt os <ArrowRight size={18} />
              </Link>
            </div>
          ) : (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="references-grid">
              {projects.map((p, i) => <ProjectCard key={p.id} p={p} i={i} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default References;
